// extracted by mini-css-extract-plugin
export default {"ambientSnowCanvas":"AmbientSnowEffect_ambientSnowCanvas__snE3V"};